import { derived } from "svelte/store";
import { teamHasDialler } from "@sourcewhale/core";
import { getTodos, getUser, getUsers } from "@sourcewhale/api";
import { SwApiStore } from "./sw-api-store";

export const userStore = SwApiStore({
  get: () => getUser(),
  onMessage: ({ message, update }) => {
    if (message.kind !== "update-teams-credit-history") return;
    message.changes.forEach((change) => {
      update((currentStore) => ({ ...currentStore, ...change.update }));
    });
  },
  cacheKey: "user",
});

export const usersStore = SwApiStore({
  get: () =>
    getUsers({
      applyAlias: true,
      includeDeleted: false,
    }),
  init: () => [],
  cacheKey: "users",
});

export const teamHasDiallerStore = derived([userStore], ([$userStore]) =>
  teamHasDialler(true, $userStore),
);

export const userTodosStore = SwApiStore({
  get: () => getTodos({}),
  onMessage: ({ message }) => {
    if (!["update-to-dos"].includes(message.kind)) return;
    userTodosStore.get();
  },
  cacheKey: "userTodos",
});

export const userDataRefreshRequestedStore = derived(
  [userStore],
  ([$userStore]) => $userStore.dataRefreshRequested,
);

export const userDiallerRequestedStore = derived(
  [userStore],
  ([$userStore]) => $userStore.diallerRequested,
);

// TODO: Remove this store as teams without AMs can also book demos with the new regional AM assignment flow
export const userCanBookFeatureDemoStore = derived(
  [userStore],
  ([$userStore]) => $userStore.isAdmin && $userStore.accountManager,
);

export const userCanBookDemoStore = derived(
  [userStore],
  ([$userStore]) => $userStore.isAdmin,
);
